<template>
  <div class="content">
    <div class="container-fluid p-0 col-6">
      <card>
        <h4 slot="header" class="card-title">Detail uživatele</h4>
        <form>
          <div class="row">
            <div class="col-12 mb-3">
              <div class="panel panel-primary" id="result_panel">
                <div class="panel-heading justify-content-between d-flex" v-if="dataLoaded">
                  <label class="panel-title pt-1">Role</label>

                  <b-button v-b-modal.modal-center variant="success" class="tableButtons" style="width: 130px !important;"><i class="fa fa-plus"></i>Přidat roli</b-button>
                  <b-modal id="modal-center" centered title="Přidat roli" @ok="addRoleToList">
                    <select class="form-control" id="roleSelect" v-model="localRoleId">
                      <option v-for="userRole in userRoles" :value="userRole.Id" :key="userRole.Id">
                          {{userRole.Name}}
                      </option>
                    </select>
                  </b-modal>
                </div>

                <div class="panel-body mt-3" v-if="dataLoaded">
                    <ul class="list-group">
                      <li class="list-group-item" v-for="userUserRole in userObject.UserUserRoles" :value="userUserRole.RoleId" :key="userUserRole.RoleId">
                        <b-button class="btn btn-danger btn-sm mr-3" @click="removeRole(userUserRole.RoleId)"><i class="fa fa-remove"></i></b-button>
                        <span>{{userUserRole.UserRole.Name}}</span>
                      </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-12">
              <base-input type="text" label="Uživatelské jméno" v-model="userObject.UserName" />
              <div v-if="submitted && !$v.userObject.UserName.required" class="invalid-feedback d-block">Uživatelské jméno je povinné</div>
            </div>
          </div>

          <div class="row pl-2 mt-3" v-if="chbChangePasswordVisible">
            <input class="ml-2 mr-2" type="checkbox" id="chbChangePassword" v-model="userObject.chbChangePasswordChecked" />
            <label for="chbChangePassword">
              Změnit heslo
            </label>
          </div>

          <div class="row" id="passwordBlock" v-if="!chbChangePasswordVisible || userObject.chbChangePasswordChecked">
            <div class="col-6">
              <base-input type="password" label="Heslo" v-model="userObject.Password" />
              <div v-if="submitted && !$v.userObject.Password.required" class="invalid-feedback d-block">Heslo je povinné</div>
            </div>
            <div class="col-6">
              <base-input type="password" label="Heslo znova" v-model="userObject.PasswordAgain" />
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <base-input type="text" label="Jméno" v-model="userObject.Name" />
              <div v-if="submitted && !$v.userObject.Name.required" class="invalid-feedback d-block">Jméno je povinné</div>
            </div>
            <div class="col-6">
              <base-input type="text" label="Příjmení" v-model="userObject.Surname" />
              <div v-if="submitted && !$v.userObject.Surname.required" class="invalid-feedback d-block">Příjmení je povinné</div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <base-input type="text" label="Email" v-model="userObject.Email" />
              <div v-if="submitted && !$v.userObject.Email.required" class="invalid-feedback d-block">Email je povinný</div>
              <div v-if="submitted && !$v.userObject.Email.email" class="invalid-feedback d-block">Špatný tvar emailu</div>
            </div>
            <div class="col-6">
              <base-input type="text" label="Telefon" v-model="userObject.PhoneNumber" />
            </div>
          </div>

          <div class="row ml-1 mt-3">
            <input class="ml-2 mr-2" type="checkbox" id="chbStayLogged" v-model="userObject.Active" />
            <label for="chbStayLogged">
              Aktivní
            </label>
          </div>

          <hr>
          <div class="text-center">
            <button type="submit" class="btn btn-success btn-fill float-right" @click.prevent="saveData">
              Uložit
            </button>
          </div>
          <div class="clearfix"></div>
        </form>
      </card>
    </div>
    <div id="snackbar">{{msg}}</div>
  </div>
</template>

<script>
  import Card from '@/components/Cards/Card.vue';
  import dataService from '@/services/dataService.js';
  import vueFormHelper from '@/js/VueFormHelper.js';
  import { required, email } from "vuelidate/lib/validators";
  import JQuery from 'jquery';

  let $ = JQuery

  export default {
    components: {
      Card
    },
    methods: {
      async saveData() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }

        if (!this.chbChangePasswordVisible || this.userObject.chbChangePasswordChecked) {
          try {
              if (this.userObject.Password !== this.userObject.PasswordAgain) {
                  throw 'Hesla se neshodují!'
              }
          } catch (error) {
              vueFormHelper.showSnackbarMessage(this, error, document);
              return;
          }
        }

        try {
          await dataService.checkUserDuplicity(this.userObject);
        } catch(error) {
          vueFormHelper.showSnackbarMessage(this, error.response.data.msg, document);
          return;
        }

        await vueFormHelper.saveData(this, $TablesEnum.user, this.userObject, '/users');
      },
      addRoleToList() {
        let roleName = $("#roleSelect option:selected").text();
        let index = this.userObject.UserUserRoles.map(function(e) { return e.RoleId; }).indexOf(this.localRoleId);

        if (index == -1)
          this.userObject.UserUserRoles.push({RoleId: this.localRoleId, UserId: this.userObject.Id, UserRole: { Name : roleName }});
      },
      removeRole(roleId) {
        let index = this.userObject.UserUserRoles.map(function(e) { return e.RoleId; }).indexOf(roleId);
        if (index > -1)
          this.userObject.UserUserRoles.splice(index, 1);
      }
    },
    mounted: async function () {
      this.newForm = this.$route.query.newForm;
      if ((this.newForm !== undefined) && (!this.newForm))
        this.userObject = this.$route.query.objectData;

      this.userRoles = JSON.parse(await dataService.getAllUserRoles(['Id', 'Name']));
      this.dataLoaded = true;

      this.chbChangePasswordVisible = !((this.newForm === undefined ? true : this.newForm) && vueFormHelper.userHasPermission(this, 13));
    },
    data () {
      return {
        msg: '',
        dataLoaded: false,
        submitted: false,
        newForm: true,
        chbChangePasswordVisible: true,
        localRoleId: -1,
        userRoles: [],
        userObject: {
          Id: -1,
          UserName: null,
          Password: null,
          PasswordAgain: null,
          Name: null,
          Surname: null,
          Email: null,
          PhoneNumber: null,
          Active: false,
          UserUserRoles: [],
          chbChangePasswordChecked: false
        }
      }
    },
    validations: {
      userObject: {
        UserName: { required },
        Password: { required },
        Name: { required },
        Surname: { required },
        Email: { required, email }
      }
    }
  }
</script>

<style>
.list-group {
  max-height: 300px;
  min-height: 100px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.modal-backdrop {
  background-color: transparent !important;
}
</style>